export default {
      id: "ic-plan-economie-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-economie-usage",
      toString: function () {
        return this.url;
      }
    }